import {
  TIMEOUT_SEC
} from './config.js';

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

export const AJAX = async function (uri, uploadData = undefined) {
  try {
    const fetchPRO = uploadData ? fetch(uri, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(uploadData)
    }) : fetch(uri);


    // Here we implement timeout functionality. The promise winning the race will be the one handled,
    // so if the first one last longer than 10 seconds, timeout promise will win and an error message
    // will be displayed in the console
    const res = await Promise.race([fetchPRO, timeout(TIMEOUT_SEC)]);
    const data = await res.json();
    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;

  } catch (err) {
    // We do that for being able to handle the error in the model. Otherwise we would 
    // have a fullfilled a promise and parent promise from model won't realize of the error 
    throw err;
  }
}